import {get, post, del, patch} from "../api"
import * as url from "../url"

const apiGetSegmentsList = data => {
  return get(url.API_SEGMENTS, data.history)
}

const apiPostSegmentsNew = data => {
  return post(url.API_SEGMENTS, data.history, data.values)
}

const apiPatchSegmentsEdit = data => {
  return patch(url.API_SEGMENTS + data.id + "/", data.history, data.values)
}

const apiDeleteSegmentsDelete = data => {
  return del(url.API_SEGMENTS + data.id + "/", data.history)
}

export {
  apiGetSegmentsList,
  apiPostSegmentsNew,
  apiPatchSegmentsEdit,
  apiDeleteSegmentsDelete,
}
